import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ElSelect, ElOption } from 'element-plus';
import { Field } from 'vee-validate';
import { useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ISelect',
  props: /*@__PURE__*/_mergeModels({
    name: {},
    items: { default: () => [] },
    size: { default: '' },
    icon: { default: '' },
    rules: { default: '' },
    width: { default: '' }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const innerValue = _useModel<string | number>(__props, "modelValue");
const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Field), {
    modelValue: innerValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    name: _ctx.name,
    rules: _ctx.rules
  }, {
    default: _withCtx(({ field, handleChange, errors }) => [
      _createElementVNode("div", null, [
        _createVNode(_unref(ElSelect), _mergeProps({
          "model-value": field.value,
          "empty-values": [undefined, null],
          size: _ctx.size === 'medium' ? '' : _ctx.size,
          "fallback-placements": ['bottom-start', 'top-start'],
          class: [_ctx.size === 'medium' && _ctx.$style.medium, _ctx.icon === 'plus' && _ctx.$style.plus, _unref(attrs).disabled && _ctx.$style.disabled, errors[0] && 'error'],
          style: _ctx.width && { width: `${_ctx.width}px` }
        }, _unref(attrs), { "onUpdate:modelValue": handleChange }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(_unref(ElOption), {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 2
        }, 1040, ["model-value", "size", "class", "style", "onUpdate:modelValue"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (errors[0])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.errorWrap)
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.error)
              }, _toDisplayString(errors[0]), 3)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "name", "rules"]))
}
}

})